import type { SampleTemplate, TemplateSortOption, TemplateFilterOption } from './types';

export const SAMPLE_TEMPLATES: SampleTemplate[] = [
  {
    name: "Prospecting - Pain Agnostic",
    subject: "Quick question about {{company}}'s goals",
    body: "Hi {{first_name}},\n\nsaw you're leading growth at {{company}} — congrats on the momentum. I wanted to reach out because we help companies like yours scale their influencer marketing campaigns without the manual overhead.\n\nAre you open to a brief chat next week to see how we can help?"
  },
  {
    name: "Case Study Follow-Up",
    subject: "Thought you'd find this case study relevant",
    body: "Hi {{first_name}},\n\nfollowing up on my last email — I thought you'd find this case study relevant. We recently helped a similar brand scale their acquisition by 40%.\n\nLet me know if you'd like to discuss how we could apply this model to {{company}}."
  },
  {
    name: "Value Prop - Short",
    subject: "Here's how we can help {{company}}",
    body: "Hi {{first_name}},\n\nwe help {{company}} teams achieve {{outcome}} without {{pain}}.\n\nOur platform automates influencer onboarding, tracking, and payments so you can focus on strategy.\n\nWould you be open to a 10-minute demo this Thursday?"
  },
  {
    name: "Re-Engagement",
    subject: "Worth reconnecting?",
    body: "Hi {{first_name}},\n\njust circling back in case now's a better time to chat about your influencer campaigns. I know things get busy!\n\nHave your goals for {{company}} changed since we last spoke?"
  },
  {
    name: "Referral Request",
    subject: "Quick favor?",
    body: "Hi {{first_name}},\n\nI've really enjoyed our conversations — would you happen to know anyone in your network who is looking to scale their creator partnerships?\n\nWe're offering a referral bonus for any successful introductions."
  },
  {
    name: "Webinar Invite",
    subject: "You're invited: {{webinar_title}}",
    body: "Hi {{first_name}},\n\nwe're hosting a webinar on {{topic}} and thought you might find it interesting. Our guest speakers will share their secrets on running high-ROI creator campaigns.\n\nRegister here: [Link]"
  },
  {
    name: "Cold Outreach - Intro",
    subject: "Introduction from {{mutual_contact}}",
    body: "Hi {{first_name}},\n\n{{mutual_contact}} suggested I reach out — I help {{company}} with their influencer seeding programs.\n\nI've been following your recent campaigns and love what you did. Do you have 5 minutes for a quick intro call?"
  },
  {
    name: "Product Update",
    subject: "What's new at {{company}}",
    body: "Hi {{first_name}},\n\nwanted to share a quick update — we just launched our new creator analytics suite. This will allow {{company}} to track exact sales attribution from every influencer post."
  },
  {
    name: "Meeting Follow-Up",
    subject: "Great talking with you",
    body: "Hi {{first_name}},\n\nthanks for taking the time to chat earlier — here's a quick recap of what we discussed.\n\nI've attached our pricing sheet and onboarding guide for {{company}}. Looking forward to our next steps!"
  }
];

export const SORT_LABELS: Record<TemplateSortOption, string> = {
  recently_updated: 'Recently updated',
  oldest: 'Oldest first',
  name_asc: 'Alphabetical (A-Z)',
  name_desc: 'Alphabetical (Z-A)',
};

export const FILTER_LABELS: Record<TemplateFilterOption, string> = {
  all: 'All templates',
  variables: 'Contains variables ({{}})',
  no_variables: 'No variables',
};
